export default __webpack_public_path__ + "static/media/painting.7cede61e.glb";